import { ApiError, parseApiResponse } from "@/lib/api/client";
import type { AdminSession, LoginResponse } from "@/lib/auth/types";

async function authFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(`/api/auth${path}`, {
    ...init,
    credentials: "same-origin",
    cache: "no-store",
  });
  return parseApiResponse<T>(response);
}

export async function fetchAdminSession(): Promise<AdminSession | null> {
  const response = await fetch("/api/auth/me", {
    method: "GET",
    credentials: "same-origin",
    cache: "no-store",
  });
  if (response.status === 401) return null;
  return parseApiResponse<AdminSession>(response);
}

export function login(username: string, password: string): Promise<LoginResponse> {
  return authFetch<LoginResponse>("/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password }),
  });
}

export function activateAccount(token: string, newPassword: string): Promise<{ ok: true }> {
  return authFetch<{ ok: true }>("/activate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, new_password: newPassword }),
  });
}

export function resetPassword(token: string, newPassword: string): Promise<{ ok: true }> {
  return authFetch<{ ok: true }>("/reset-password", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, new_password: newPassword }),
  });
}

export function safeReturnTo(value: string | null | undefined): string {
  if (!value || !value.startsWith("/") || value.startsWith("//") || value.includes("\\")) {
    return "/";
  }
  try {
    const parsed = new URL(value, "http://sinseon.local");
    if (parsed.origin !== "http://sinseon.local") return "/";
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return "/";
  }
}

export function authErrorMessage(error: unknown): string {
  return error instanceof ApiError ? error.message : "요청을 처리하지 못했습니다.";
}
